<template>
  <div class="loties encart" v-if="filteredLoties.length > 0">
      <h2>Liste des loties disponibles</h2>
      <table>
        <thead>
          <tr>
            <th>Numéro de série</th>
            <th>Quantité</th>
            <th>Magasin</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="(lotie, index) in filteredLoties" :key="lotie.id" class="articles"
                :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'"> 
  
              <td>{{ lotie.numero_serie }}</td>
              <td>{{ lotie.quantite }}</td>
              <td>{{ lotie.nom_magasins }}</td>
            </tr>
        </tbody>
      </table>
   
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'



export default {
  data() {
    return {
      loties: [],
      codeArticle: '',
    }
  },
  created() {
    this.codeArticle = this.$route.params.codeArticle;
  },
  mounted() { 
    


    axios.get(`https://www.simef.fr/espace-client/api/getLoties.php?coarti=${this.codeArticle}`)
    .then(response => {
      this.loties = Array.isArray(response.data?.loties) ? response.data.loties : [];
    })
    .catch(error => {
      // Some backend responses incorrectly use HTTP 500 with a valid JSON payload.
      const fallbackData = error?.response?.data;
      if (Array.isArray(fallbackData?.loties)) {
        this.loties = fallbackData.loties;
        return;
      }
      console.error(error);
    });
  }, 
  computed: {
    filteredLoties() {
      return this.loties.filter(lotie => lotie.quantite > 0);
    },
  },
  methods: {
  
  }

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  .loties {
    margin-bottom: 25px;
  }
  h2 {
    text-align: left;
  }
  .loties {
    table {
      width: 100%;
      tr {
        border-bottom: 1px solid #1d1d20;
      }
      tr, thead {
        &:last-child {
          border: 0px;
        }
      }
  }
 
  }

</style>
